<!-- 企业级-业务领域-仓储业务-盘点记录 -->
<template>
  <div class="mainArea CStoreRecord">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <el-input class="w200" placeholder="盘点单号" v-model="keyword.number" clearable @keyup.enter.native="GetCheckStorage(1)"></el-input>
          <el-select placeholder="盘点类型" v-model="keyword.type" clearable>
            <el-option value="1" label="日常盘点"></el-option>
            <el-option value="2" label="月盘点"></el-option>
            <el-option value="3" label="季盘点"></el-option>
            <el-option value="4" label="年度盘点"></el-option>
            <el-option value="5" label="临时盘点"></el-option>
          </el-select>
          <el-date-picker
            v-model="keyword.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="GetCheckStorage(1)">
          </el-date-picker>
          <!-- <el-select v-model="keyword.status" placeholder="请选择状态" clearable @change="GetCheckStorage(1)">
            <el-option label="" value=""></el-option>
          </el-select> -->
          <el-button class="searchBtn" type="primary">搜 索</el-button>
        </div>
        <!-- 添加预约信息 -->
        <div class="addButton">
          <el-button type="primary" @click="toAddStore">添加</el-button>
          <el-button type="primary">生成报表</el-button>
        </div>

        <el-table v-loading="loading" :data="tableData" style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="盘点单号" prop="OrderSn"></el-table-column>
          <el-table-column label="制单来源" prop="Source"></el-table-column>
          <el-table-column label="盘点类型" prop=""></el-table-column>
          <el-table-column label="盘点时间">
            <template slot-scope="scope">
              {{scope.row.StartTime}}~{{scope.row.EndTime}}
            </template>
          </el-table-column>
          <el-table-column label="盘点情况" prop=""></el-table-column>
          
          <!-- <el-table-column label="状态">
            <template slot-scope="scope">
              <span class="status1" v-if="scope.row.Status==0">待审核</span>
              <span class="status2" v-else-if="scope.row.Status==1">审核通过</span>
              <span class="status3" v-else-if="scope.row.Status==2">审核不通过</span>
            </template>
          </el-table-column>
          <el-table-column label="审核时间" prop="CreateTime"></el-table-column>
          <el-table-column label="盘点情况">
            <template slot-scope="scope">
              <span class="status2" v-if="scope.row.CheckStatus==1">正常</span>
              <span class="status3" v-else-if="scope.row.CheckStatus==2">异常</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!--审核通过的用查看按钮-->
              <!-- <el-button type="text" @click="openDio(scope.row,'detail')">审核</el-button> -->
              <!-- <el-button type="text">查看</el-button> -->
              <el-button type="text">打印</el-button>
              <el-button type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total>limits">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="limits"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <el-dialog :title="dioTitle" :visible.sync="recordDio" :width="dioWidth" class="configDio wareDio" center>
        <div class="contDio">
          <div class="info">
            <div>
              <span>盘点单号：{{dioform.OrderSn}}</span>
              <span>盘点时间：{{dioform.EndTime}}</span>
            </div>
            <div>
              <span>制单来源：{{dioform.sourse}}</span>
              <span>制单人：{{dioform.CheckUserName}}</span>
            </div>
            <!-- <div>
              <span>备注：12314894845645</span>
            </div> -->
          </div>
          <div class="serach">
            <el-input class="w200" v-model="dioform.number" placeholder="档案编号" clearable></el-input>
            <el-input class="w200" v-model="dioform.productName" placeholder="档案名称" clearable></el-input>
            <el-select v-model="dioform.type" placeholder="请选择类别" clearable>
              <el-option label="" value=""></el-option>
            </el-select>
          </div>
          <div class="serach mt10">
            <el-input class="w200" v-model="dioform.supplier" placeholder="输入关键词搜索或双击选择供应商" clearable></el-input>
            <el-cascader @change="cargoChange" placeholder="请选择货位信息" :options="dioform.cargoList" :props="dioform.props" :show-all-levels="false" clearable></el-cascader>
            <el-button type="primary">搜索</el-button>
          </div>
          <el-table :data="dioform.tabData" style="width: 100%" max-height="300">
            <el-table-column label="档案编号" prop="ProductSn"></el-table-column>
            <el-table-column label="档案名称" prop="ProductName"></el-table-column>
            <el-table-column label="类别" prop="CategoryName"></el-table-column>
            <!-- <el-table-column label="责任人" prop=""></el-table-column> -->
            <el-table-column label="区" prop="StorageLocation"></el-table-column>
            <el-table-column label="列" prop="StorageRack"></el-table-column>
            <el-table-column label="层" prop="Zhy"></el-table-column>
            <!-- <el-table-column label="仓库" prop=""></el-table-column>
            <el-table-column label="库位" prop=""></el-table-column>
            <el-table-column label="货架" prop=""></el-table-column>
            <el-table-column label="货位" prop=""></el-table-column>
            <el-table-column label="系统库存" prop=""></el-table-column> -->
            <el-table-column label="盘点情况">
              <template slot-scope="scope">
                <span v-if="scope.row.CheckStatus=='1'">正常</span>
                <span v-else-if="scope.row.CheckStatus=='1'">盘盈</span>
                <span v-else-if="scope.row.CheckStatus=='2'">盘亏</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging" v-if="dioform.total>dioform.limits">
            <el-pagination
              @current-change="dioCurrChange"
              :current-page.sync="dioform.curr"
              :page-size="dioform.limits"
              layout="prev, pager, next, jumper"
              :total="dioform.total">
            </el-pagination>
          </div>
          <div class="mt10">
            <el-input v-model="dioform.auditOpinion" placeholder="审核意见"></el-input>
          </div>
          <div class="foot">
            <el-button @click="recordDio = false">关闭</el-button>
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb,localUserInfo } from "../../../../../static/js/utility/utility.js"
  import { bussinessApi } from "../../../../../static/js/api.js"

  export default {
    name: 'CStoreRecord',
    components: {
      CBreadCrumb,
    },
    data() {
      return {
        //搜索
        keyword:{
          number:'',//盘点单号
          time:[],//盘点时间区间
          status:'',//状态
          type:'',//盘点类型
        },

        loading:false,
        tableData:[],//仓库数据

        //分页
        curr:1,
        limits:10,
        total:0,

        recordDio:false,//弹窗
        dioTitle:'添加仓库',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        dioform:{
          OrderSn:'',//盘点单号
          sourse:'',//来源
          time:'',//盘点时间
          number:'',//产品编号
          CheckUserName:'',//制单人
          productName:'',//产品名称
          type:'',//类型
          supplier:'',//供应商
          cargo:'',//货位
          auditOpinion:'',//审核意见

          tabData:[],

          curr:1,
          limits:10,
          total:0,

          cargoList:[{
            id:'1',
            name:'一级',
            children:[{
              id:'2',
              name:'二级'
            }]
          }],
          props:{
            checkStrictly: true,
            label:'name',
            value:'id',
            children:'children'
          },

        },
      };
    },
    mounted(){

    },
    created: async function () {
      this.GetCheckStorage()
    },
    methods: {
      //获取盘点记录列表
      async GetCheckStorage(curr,limits){
        let that = this;
        this.loading = true
        const data = {
          'StartTime': that.keyword.time ? that.keyword.time[0]:'',//开始时间
          'EndTime': that.keyword.time ? that.keyword.time[1]:'',//结束时间
          'OrderSn': that.keyword.number,//订单号
          'Page': curr ? curr : that.curr,
          'PageSize': limits ? limits :that.limits,
          'CompanyId': localUserInfo.getItem().company_id,
        }
        const res = await bussinessApi.GetCheckStorage(data)
        this.loading = false
        if(res.ErrCode == 0){
          that.tableData = res.Result.list
          that.curr = res.Result.PageIndex
          that.tatal = res.Result.Total
        }
      },
      //打开弹窗
      openDio(data,type){
        this.dioType = type
        if(type == 'detail'){
          this.dioWidth="900px"
          this.dioTitle="盘点单详情"
          this.dioform.OrderSn = data.OrderSn
          this.dioform.sourse = data.Sourse
          this.dioform.time = data.StartTime+'~'+data.EndTime
          this.dioform.CheckUserName = data.CheckUserName
        }
        this.recordDio = true
      },
      //货位选择
      cargoChange(value){
        this.dioform.cargo = value
      },
      //获取单号详情
      async GetCheckStorageDetails(curr,limits){
        let that = this;
        this.loading = true
        const data = {
          'CheckId': that.dioform.OrderSn,//订单号
          'ProductName': that.dioform.productName,//档案名称
          'ProductSn': that.keyword.number,//档案编号
          'Page': curr ? curr : that.dioform.curr,
          'PageSize': limits ? limits :that.dioform.limits,
        }
        const res = await bussinessApi.GetCheckStorageDetails(data)
        this.loading = false
        if(res.ErrCode == 0){
          that.dioform.tabData = res.Result.list
          that.dioform.curr = res.Result.PageIndex
          that.dioform.tatal = res.Result.Total
        }
      },

      //跳转到添加盘点单
      toAddStore(){
        var navBarActive = [{function_tab: 'CAddStore', function_name: '添加盘点单'}]
        // 更新面包屑内容
        updataBreadCrumb(4, navBarActive)
        this.$router.push({
          path:'/CAddStore'
        })
      },

      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
        this.GetCheckStorage(val)
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CStoreRecord{
  .w100{
    width: 100px;
  }
  .w200{
    width: 200px;
  }
  .w300{
    width: 300px;
  }
  .status1{
    color: #409EFF;
  }
  .status2{
    color: #67C23A;
  }
  .status3{
    color: #F56C6C;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
    }
  }

  .addButton {
    margin-bottom: 24px;
  }
  .contDio{
    .info{
      span{
        margin-right: 30px;
        margin-bottom: 10px;
        display: inline-block;
      }
    }
    .foot{
      text-align: right;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CStoreRecord/CStoreRecord.vue